enum ImportRestrictionValue {
  OWNER = "owner",
  OWNER_MANAGERS = "owner-manager",
  ALL_USERS = "public",
}

export default ImportRestrictionValue;
